import React, {useRef, useState} from 'react';
import {shallowEqual, useSelector} from "react-redux";
import {FiCheck} from "react-icons/fi";
import {Form} from "react-final-form";
import {Button} from "../My/Button";
import Portal from "../portal";
import CogoToast from "cogo-toast";
import CheckboxField from "../FinalForm/CheckboxField";

const ConfirmRegisterExponat = ({onAccept, visible, setVisible}) => {

    const {palettes} = useSelector(
        (state) => ({
            palettes: state.palettes,
        }),
        shallowEqual
    )

    let {background} = {
        ...palettes
    }

    const modalRef = useRef(null)

    const send = (values) => {
        if(!values.accept){
            CogoToast.error("Musíte souhlasit s podmínkami.")
        }else{
            setVisible(false);
            onAccept();
        }
    }

    if (visible) {
        return (
            <Portal selector="#portal">
                <div className="modal-backdrop fade-in bg-blue-500"></div>
                <div className={`modal show ${background === 'dark' ? 'dark-mode' : ''}`}
                     data-background={background}>
                    <div className="relative min-w-sm w-3/4 mx-auto lg:max-w-5xl bg-white rounded" ref={modalRef}>
                        <div className="modal-content">
                            <Form onSubmit={send} render={({handleSubmit}) => (
                                <>
                                    <div className={"m-5 text-lg text-justify flex flex-col space-y-5"}>
                                        <div className={"font-bold"}>Souhlas s podmínkami registrace</div>
                                        <div>
                                            Dokončením této registrace potvrzujete svůj souhlas s&nbsp;dodržování všech postupů a podmínek registrace, stejně jako s&nbsp;návštěvním řádem
                                            slavnosti LEGENDY. Prosíme o jejich respektování, aby byla zajištěna hladká organizace akce.
                                        </div>
                                        <div>
                                            Pokud by se majitel zaregistrovaného a schváleného exponátu <b>nemohl akce zúčastnit, žádáme o informování předem.</b>
                                        </div>
                                        <div>
                                            V případě, že k neúčasti dojde bez předchozího oznámení, může být účtován <b>administrativní poplatek ve&nbsp;výši&nbsp;1.500&nbsp;Kč</b>.
                                            Tento poplatek slouží k pokrytí nákladů spojených s&nbsp;přípravou místa pro vystavování vozu.
                                            <br/>Platební údaje a pokyny k úhradě budou v takovém případe zaslány do&nbsp;7&nbsp;dnů po skončení akce.
                                        </div>
                                        <br/>
                                        <div>
                                            Děkujeme za pochopení, ohleduplnost a dodržování pravidel.
                                        </div>
                                        <br/>
                                        <div>
                                            Velmi si Vaší účasti vážíme a těšíme se na setkání!
                                        </div>
                                        <div className={"w-full text-center font-bold"}>
                                            <CheckboxField name={"accept"} isMandatory={false} label={"Souhlasím s podmínkami registrace vozu"}/>
                                        </div>
                                    </div>

                                    <div className="modal-footer space-x-2">
                                        <Button onClick={handleSubmit}
                                                text={"Potvrdit"} icon={<FiCheck/>}/>
                                    </div>
                                </>
                            )}/>
                        </div>
                    </div>
                </div>
            </Portal>
        )
    } else {
        return <></>
    }
}

export default ConfirmRegisterExponat;
